<template>
    <split-pane  :min-percent='20' :default-percent='25' split="vertical" style="background:white; height:100%"> 
        <template slot="paneL">
            <div style="background:#fff; padding-top:2px;border-bottom:1px solid #389;line-height:30px;padding-left:1px"> 
                <el-input clearable ref="refinput" :placeholder="input_hold" v-model="textparam" size="small" @keyup.enter.native="qryTabData" style="width:400px;height:30px;">
                    <el-select  v-model="selparam" slot="prepend" placeholder="请选择列名" clearable @change="elchange" style="width:140px; ">
                        <span v-for="item in tabCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" style="color:#409eff" slot="append" icon="el-icon-search" @click="qryTabData"></el-button>
                </el-input> 
            </div>
            <el-table  :data="baseData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:1px;"
                    v-loading="loading"
                    size="small"
                    @row-click="baseRowClick"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :height="tabHigh" 
                    ref="formref"    
                    highlight-current-row>
                 
                    <el-table-column   v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                    </el-table-column> 
                                   
            </el-table>
            <div style="background:#fff; line-height:30px;margin-top:10px;border-left:3px solid #409eff"> 
                <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                <el-link :disabled="disabled" @click="addTab" :underline="false" style="margin-top:-2px;"><span style="font-size:13px;margin-right:15px;">新增表名</span></el-link>
            </div>
            <el-table  :data="tableData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="200" 
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :row-key="getFldKey"  
                    ref="tabref"
                    @row-click="tabClick"  
                    highlight-current-row>
                <el-table-column label="序号" type="index" width="55"></el-table-column>       
                <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                </el-table-column> 
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="120">
                    <template slot-scope="scope">
                        <!-- <i class="iconfont icon-xiazai" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="disabled" @click="impTab(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">导入</span></el-link> -->
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="disabled" @click="editTab(scope.row,scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px;">编辑 </span></el-link>
                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;margin-left:5px;"></i>
                        <el-link :disabled="disabled" @click="delTab(scope.row )" :underline="false"  ><span style="font-size:12px;">删除 </span></el-link>     
                    </template>
                </el-table-column>                      
            </el-table>   
        </template>
        <template slot="paneR">
            <div style="background:#fff; display:flex;padding-top:2px;border-bottom:2px solid #389;line-height:30px"> 
                <div style="width:72px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="disabled" @click="addRec" :underline="false" style="margin-top:-2px;"><span style="font-size:13px ">新增 </span></el-link>
                </div>
                <el-input :placeholder="input_hold2" v-model="textparam2" size="small" @keyup.enter.native="qryTabData2" style="width:420px;margin-left:10px; height:30px;">
                    <el-select v-model="selparam2" slot="prepend" placeholder="请选择列名" clearable @change="elchange2" style="width:140px; ">
                        <span v-for="item in tabCol2" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" style="color:#409eff" slot="append" icon="el-icon-search" @click="qryTabData2"></el-button>
                </el-input> 
                <el-button style="margin-left:10px" type="danger" size="mini" icon="iconfont icon-baocun" @click="saveSort" >保存排序</el-button>
                <el-button style="margin-left:20px" type="warning" size="mini" icon="iconfont icon-xiazai" @click="expData" >导出数据</el-button>
                <el-button style="margin-left:20px" type="primary" size="mini" icon="iconfont icon-baocun" @click="saveData" >保存复制数据</el-button>
            </div>
            <div ref="tableWrap"  >
                <el-table  :data="baseData2" 
                        border                            
                        disabled-hover
                        class="custom-table-border draggable-table"
                        style="overflow:auto;margin-top:1px;"
                        size="small"
                        :row-key="getFldKey"  
                        :height="tabHeight" 
                        :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                        v-loading="v_loading"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"
                        ref="fldref"    
                        highlight-current-row>
                    <el-table-column  v-for="(item,index) in tabCol2.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"   
                        :sortable="item.sortable=='N'"                            
                        :min-width="item.width">
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss==='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" ></el-checkbox>
                            <span class="handle" v-else-if="item.key=='SORTBY'"><i class="iconfont icon-yidong"></i>{{scope.row[item.key] }}</span> 
                            <el-input  readonly @focus="onCellFocus(scope.$index, index)"   v-else-if="item.key=='FLDEN'||item.key=='FLDYN'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                            <span v-else>{{scope.row[item.key]}}</span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                            fixed="right"
                            label="操作"
                            align="center"
                            width="150">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="disabled" @click="editRec(scope.row )" :underline="false"  ><span style="font-size:13px;margin-right:10px;">编辑 </span></el-link>
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:10px;"></i>
                            <el-link :disabled="disabled" @click="delRec(scope.row ,scope.$index)" :underline="false"  ><span style="font-size:13px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                       
                </el-table>
            </div>
            <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
                <div style="float: left;padding-left:4px;font-size:12px;">
                    <Page :total="dataCount" :page-size="rowSize" show-total :current="v_current" @on-change="changePage"></Page>
                </div>
            </div>
            <el-dialog v-dialogDrag :visible.sync="tabModal" width="390px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{type==='create'?'新增表名':'编辑表名'}}</span>
                </div>   
            
                <div style="display:flex">
                    <div style="font-size:12px;margin-right:10px;width:80px;text-align:right">明细ID</div>
                    <el-input type="text" disabled size="small" v-model="tablstseq" style="width:240px;"></el-input>
                </div>
                <div style="display:flex;margin-top:20px;">
                    <div style="font-size:12px;margin-right:10px;width:80px;text-align:right">实体表名称</div>
                    <el-input type="text" size="small" v-model="tabnm" style="width:240px;"></el-input>
                </div>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; margin-top:10px;">
                    <span style="float:right">
                        <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="tabModal=false" style="margin-right:30px;">取消</el-button>
                        <el-button type="primary" icon="iconfont icon-baocun"  size="small" @click="tab_Save"  >保存</el-button>
                    </span>
                </div>
            </el-dialog>
            <el-dialog v-dialogDrag :visible.sync="fldModal" width="1000px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">字段操作</span>
                </div>
                <Form ref="addForm" :model="formCol2" :label-width="100"  :rules="ruleValidate"  label-position="right" inline >
                    <span v-for="(item,index) in tabCol2" :key="index" >
                        <FormItem :label="item.title" :prop="item.key" v-if="item.fhide==='N'">                                  
                            <el-checkbox border v-if="item.edcss==='checkbox'" true-label="Y"  false-label="N" v-model="formCol2[item.key]" style="width:200px;"></el-checkbox>    
                            <el-select v-else-if="item.edcss==='select' && item.key==='EDCSS'" v-model="formCol2[item.key]" style="width:200px;" clearable filterable>                            
                                <el-option  v-for="(itsel,index) in editCss" :value="itsel.SUBNO" :key='index' :label="itsel.CNAME"> </el-option>   
                            </el-select>
                            <el-select v-else-if="item.edcss==='select' && item.key==='CSS'" v-model="formCol2[item.key]" style="width:200px;" clearable filterable>                            
                                <el-option v-for="(itsel,index) in alignArr" :value="itsel.SUBNO" :key='index' :label="itsel.CNAME"> </el-option>   
                            </el-select>
                            <el-select v-else-if=" item.key==='CL'" v-model="formCol2[item.key]" style="width:200px;" clearable filterable>                            
                                <el-option v-for="(itsel,index) in clArr" :value="itsel.SUBNO" :key='index' :label="itsel.CNAME"> </el-option>   
                            </el-select>
                            <el-select v-else-if=" item.key==='COMBO'" v-model="formCol2[item.key]" style="width:200px;" clearable filterable>                            
                                <el-option v-for="(itsel,index) in comboArr" :value="itsel.CODE" :key='index' :label="itsel.CNAME"> </el-option>   
                            </el-select>
                            <el-select v-else-if="item.edcss==='select' && item.key==='GPNM'" v-model="formCol2[item.key]" style="width:200px;" clearable filterable>                            
                                <el-option v-for="(itsel,index) in gpArr" :value="itsel.CNAME" :key='index' :label="itsel.CNAME"> </el-option>   
                            </el-select>
                            <el-input type="number" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'"  v-model="formCol2[item.key]" style="width:200px"> </el-input> 
                            <el-input v-else type="text" :disabled="item.disabled=='Y'?true:false " v-model="formCol2[item.key]"  style="width:200px;" clearable/>
                        </FormItem>
                    </span>
                </Form>
                <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:10px ">
                    <span style="float:right">
                        <el-button type="info" icon="iconfont icon-shanchu" size="small"  @click="fldModal=false" style="margin-right:40px;">取消</el-button>
                        <el-button type="primary" icon="iconfont icon-baocun"  size="small" @click="fld_Save"  >保存</el-button>
                    </span>
                </div>
            </el-dialog>  
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <el-image  src="/assets/authorize/loading.gif" ></el-image>  
            </el-dialog>
        </template>
    </split-pane>  
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user'
import Sortable from 'sortablejs'
import { getDate,getDate2} from '../../api/Select' 
export default{  
    name: "sys_formfld",
    data () {
            return {
                fldModal:false, //modal 
                tabModal:false,
                disabled:false,
                promptWin:false,
                prompt:'',
                textparam:'', // input 绑定值
                selparam:'FRMNM',// select 绑定值
                textparam2:'', // input 绑定值
                selparam2:'FLDNO',// select 绑定值
                tabCol:[] ,//表列集合
                tabCol2:[] ,//表列集合
                v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
                input_hold:'请输入内容...',
                input_hold2:'请输入内容...',
                baseData:[] ,//表数据
                baseData2:[] ,//表数据
                tableData:[],
                formArr:[] , //保存取到所有数据
                formCol2:{}, //表格单行记录 model
                rowIndex:'-1', //行号 
                rowIndex2:'-1', //行号 
                comboArr:[],
                // 初始化信息总条数
                type:'create',
                loading:false,// table加载bool
                tablstseq:'',
                rowIdseq:'-1',
                rowIdseq2:'-1',
                lstseq:'',
                rowLstseq2:'-1',
                tabArr:[],
                tabnm:'',
                ruleValidate: {},
                notNull:[],
                alignArr:[],//编辑样式数组:对齐方式
                editCss:[] ,//编辑样式数组:表单组件
                clArr:[],
                gpArr:[],
                stfgBool:true,
                v_sys:this.$cookies.get('v_sys'), //系统标志
                v_url:'xuper_auth/getTableRecMany', //api请求路径
                v_likeurl:'xuper_auth/getLikeManyRec', //多记录查询 like模式
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                  
                dataCount:0,
                v_current:1,
                rowSize:100,
                allList:[],
                v_loading:false,
                loadWin:false,
                focusRow: 0,
                focusCol: 0,
                v_operData:[],
            }
        },
        watch: {
 
        },
        created () {
            //if (this.v_sys==='N'){ 
                //this.disabled =true
            //}
            if (this.v_username){  
                //对齐样式 
                getBaseData('xuper_auth/getBaseData','parentno','148','','','v_sys_base','').then(res=>{
                    this.alignArr =res.result
                })
                //分组名称
                getBaseData('xuper_auth/getBaseData','parentno','302','','','v_sys_base','').then(res=>{
                    this.gpArr =res.result
                })
                //编辑样式
                getBaseData('xuper_auth/getBaseData','parentno','140','','','v_sys_base','').then(res=>{
                    this.editCss =res.result
                })   
                getBaseData('xuper_auth/getBaseData','parentno','438993','','','v_sys_base','').then(res=>{
                    this.clArr =res.result
                }) 
                
                //下拉选项
                getBaseData('xuper_auth/getBaseData','','','','','v_combo','').then(res=>{
                    this.comboArr =res.result
                })   
                this.getTabCol()
                this.getTabCol2()
                this.getFormData()
            }else{ //没有登录时转到主页
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        beforeDestroy() {
            // 组件销毁时移除监听
            this.$refs.tableWrap.removeEventListener('paste', this.handlePaste)      
        },
        mounted () {
            // 监听粘贴事件
            this.$refs.tableWrap.addEventListener('paste', this.handlePaste) //将事件绑定到表格容器
            //动态生成表单验证规则
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','90','lstseq','3','NOTNULL','Y').then((res) => {
                let ruleObj={}
                let ruleVal=[]
                this.notNull = res.result
                res.result.forEach(item => {
                    let v_fldnm =item.FLDNM
                    let obj1={required:true,message:v_fldnm+'不能为空'}
                    ruleVal =[]
                    ruleVal.push(obj1)
                    ruleObj[item.FLDNO]=ruleVal                  
                });
                this.ruleValidate =ruleObj
            })
            this.$nextTick(()=>{
                this.$refs['refinput'].focus()
            })
            const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody')
                new Sortable(tbody, {
                    handle: '.handle', // handle's class
                    animation: 150,
                    // 需要在odEnd方法中处理原始eltable数据，使原始数据与显示数据保持顺序一致
                    onEnd: ({ newIndex, oldIndex }) => {
                        const targetRow = this.baseData2[oldIndex]
                        this.baseData2.splice(oldIndex, 1)
                        this.baseData2.splice(newIndex, 0, targetRow)
                    },
            })
        },
        computed: {
            tabHigh(){
                return window.innerHeight-380+ 'px'
            } ,
            tabHeight(){
                return window.innerHeight-155+ 'px'
            }   
        },
        methods: { 
            onCellFocus(rowIndex, colIndex) {
                this.focusRow = rowIndex
                this.focusCol = colIndex+1
            },
            handlePaste(e) {
                //if (this.saveFlag==false){
                    const text = (e.clipboardData || window.clipboardData).getData('text')
                    if (!text) return

                    // 1. 统一换行符，按行拆分
                    const lines = text
                    .replace(/\r\n/g, '\n')
                    .replace(/\r/g, '\n')
                    .split('\n')

                    // 2. 按 Tab 拆分每一行的列，过滤空行
                    const parsed = lines
                    .map(line => line.split('\t'))
                    .filter(cols => cols.some(c => c.trim() !== ''))

                    if (parsed.length === 0) return

                    // 阻止默认粘贴行为（避免写入 input）
                    e.preventDefault()

                    // 3. 如果粘贴内容超出行数，自动追加空行
                    const neededRows = this.focusRow + parsed.length
                    while (this.baseData2.length < neededRows) {
                        this.baseData2.push(this.createEmptyRow())
                    }

                    // 4. 从聚焦位置开始，逐行逐列填入数据
                    parsed.forEach((cols, ri) => {
                        const v_row =this.baseData2[this.focusRow + ri]
                        if (v_row['IDSEQ'] && v_row['LSTSEQ']){
                            this.v_operData.push({IDSEQ:v_row['IDSEQ'],LSTSEQ:v_row['LSTSEQ'],ITMSEQ:v_row['ITMSEQ'] })
                        } 
                        
                        cols.forEach((val, ci) => {
                            const targetRow = this.focusRow + ri
                            const targetCol = this.focusCol + ci
                            if (targetCol < this.tabCol2.length) {
                                const prop = this.tabCol2[targetCol].key
                                this.$set(this.baseData2[targetRow], prop, val.trim())
                            }
                        })
                    })
                    //console.log(JSON.stringify(this.v_operData))
                //}
            },
            //生成一个空行对象
            createEmptyRow() {
                const row = {}
                this.tabCol2.forEach(col => {
                    row[col.prop] = ''
                })
                return row
            },
            saveData(){
                this.loadWin =true
                const v_data =this.baseData2.filter(item=>this.v_operData.some(it=>it['IDSEQ']==item['IDSEQ']&&it['LSTSEQ']==item['LSTSEQ']&&it['ITMSEQ']==item['ITMSEQ'])) 
                let vm =this
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/batchBodySave2',
                    data: {p_json:JSON.stringify(v_data), p_table:'sys_form_fld',p_user:vm.v_username},
                }).then(res=>{    
                    if(res.result =='OK')  {          
                        this.$Message.info('已保存')
                        this.v_operData=[]
                        this.loadWin =false
                    }else{
                        this.loadWin =false
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            },
            expData(){
                this.loadWin =true   
                //导出
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/report/GenExcel',
                    data: {p_idseq:'90',p_lstseq:'3',p_json:JSON.stringify(this.allList),p_action:'字段明细'},
                    responseType:'blob' //关键，声明响应类型为二进制流
                }).then(response=>{ 
                    // 从响应头解析后端设置的文件名
                    // 创建Blob对象并触发下载  创建下载链接
                    const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob)
                    link.download = '字段明细_'+getDate('full')+'.xls'
                    link.click()
                    URL.revokeObjectURL(link.href)
                    this.loadWin =false
                }) 
            },
            changePage(index){
                var _start = ( index - 1 ) * this.rowSize;
                var _end = index * this.rowSize
                this.v_current =index
                this.baseData2 = this.allList.slice(_start,_end);
            },
            //初始化查询页条数
            initPage(){
                //产品明细
                this.dataCount =this.allList.length //总条数
                // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
                if (this.allList.length < this.rowSize){
                    this.baseData2 = this.allList          
                }else{
                    this.baseData2 =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.fldref.doLayout()
                }) 
            },
            saveSort(){
                if (this.rowIdseq2 >0){
                    this.allList.forEach((item,index)=>{
                        let v_num =Number(index+1)
                        item['SORTBY'] =v_num
                        let v_cond =' set sortby='+v_num
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:item['IDSEQ'],p_key2:'lstseq',p_value2:item['LSTSEQ'],p_key3:'itmseq',p_value3:item['ITMSEQ'],p_table:'sys_form_fld',p_cond: v_cond},
                        }).then(res=>{ 
                            //item['SORTBY'] =index+1
                        })
                    })
                }else{
                    this.promptWin =true
                    this.prompt ='字段名称为空，请核查'
                }
            },
            //实体表保存
            tab_Save(){
                if (this.tabnm){
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify({TABNM:this.tabnm,LSTSEQ:this.tablstseq}), p_table:'sys_form_tab',p_idseq:this.rowIdseq },
                    }).then(res=>{      
                        if(res.result ==='OK')  {          
                            this.tabModal =false
                            this.rowIdseq2='-1'
                            this.getFormTable('idseq', this.rowIdseq) 
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                    
                }else{
                    this.promptWin=true
                    this.prompt='实体表名称不能为空'
                }
            },
            //表单行点击
            baseRowClick(row){
                this.rowIdseq =row.IDSEQ
                this.rowIdseq2='-1'
                this.rowLstseq2='-1'
                this.getFormTable('idseq', row.IDSEQ ) 
            }  ,
            getFldKey(row){
                return row.PKSEQ
            },     
            //字段保存
            fld_Save(){
                var vm=this;
                if (this.notNull.length>0){
                    this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                        if (!this.formCol2[item.FLDNO] ){
                        this.stfgBool =false 
                        this.promptWin=true
                        this.prompt=item.FLDNM+'不能为空'
                        return true
                        }else{
                        this.stfgBool =true  
                        }
                    })
                }
                //发起保存请求   
                if (this.stfgBool)       
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/tableBodySave2',
                    data: {p_json:JSON.stringify(vm.formCol2), p_table:'sys_form_fld',p_user:vm.v_username},
                }).then(res=>{    
                    if(res.result =='OK')  {          
                        vm.fldModal =false  
                        this.getFrmFldData('idseq',this.rowIdseq2 ,'lstseq',this.rowLstseq2 ,'')  
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            },
            //实体表 增册改
            addTab(){
                this.tabModal =true
                this.type ='create'
                this.tabnm =''
                this.tablstseq=''
            },
            impTab(row,index){

            },
            editTab(row,index){
                if (row['ADDUSER'] ==this.v_usernm || this.v_usernm=='彭建武'){
                    this.tabModal =true
                    this.type ='edit'
                    this.tabnm =row.TABNM
                    this.tablstseq=row.LSTSEQ
                }else{
                    this.promptWin=true
                    this.prompt='不能编辑非本用户记录'
                }
            },
            delTab(row){
                if (row['ADDUSER']==this.v_usernm || this.v_usernm=='彭建武'){
                    if (!row.IDSEQ){
                        this.promptWin=true
                        this.prompt='请选择表记录'
                    }else{
                        this.$Modal.confirm({
                            title: '删除确认',
                            content: '<p>你确定要删除此行记录吗</p>',
                            onOk: () => {
                                //发起删除请求
                                var vm=this;
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_table:'sys_form_tab'},
                                }).then(res=>{      
                                    if(res.code =='200')  { 
                                        vm.rowIdseq2='-1'          
                                        vm.getFormTable('idseq', this.rowIdseq)     
                                    }else{
                                        if(res.result.indexOf('ORA-02292')>-1){
                                            this.promptWin=true
                                            this.prompt='存在子记录，不能删除'
                                        }else{
                                            this.$alert(res.result, '提示', {
                                                confirmButtonText: '确定',
                                                showClose:false,
                                                type:'info'
                                            })
                                        }
                                    }        
                                }) 
                            }
                        });
                    }
                }else{
                    this.promptWin=true
                    this.prompt='不能操作非本用户记录'
                }
            },
            //表字段操作
            addRec(){
                this.fldModal =true
                this.formCol2 ={'IDSEQ':this.rowIdseq,'LSTSEQ':this.rowLstseq2,'NOTNULL':'N','THIDE':'N','FHIDE':'N','DISABLED':'N','GEN':'N','SORTABLE':'N'}
            },
            editRec(row){
                 
                if (row['ADDUSER'] ==this.v_usernm || this.v_usernm=='彭建武'){
                    this.fldModal =true
                    this.formCol2 =JSON.parse(JSON.stringify(row))
                }else{
                    this.promptWin=true
                    this.prompt='不能操作非本用户记录'
                }
            },
            delRec(row,index){
                if (row['ADDUSER']==this.v_usernm || this.v_usernm=='彭建武'){
                    this.$Modal.confirm({
                        title: '删除确认',
                        content: '<p>你确定要删除此行记录吗</p>',
                        onOk: () => {
                            //发起删除请求
                            var vm=this;
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:row.IDSEQ,p_key2:'lstseq',p_value2:row.LSTSEQ,p_key3:'itmseq',p_value3:row.ITMSEQ,p_table:'sys_form_fld'},
                            }).then(res=>{      
                                if(res.code =='200')  {      
                                    vm.baseData2.splice(index,1 )      
                                }else{
                                    this.promptWin=true
                                    this.prompt=res.result
                                }        
                            }) 
                        }
                    })
                }else{
                    this.promptWin=true
                    this.prompt='不能操作非本用户记录'
                }
            },
            elchange(val){
                let obj ={}
                obj =this.tabCol.find(item=>{
                    return item.key===val
                })
                this.input_hold='请输入'+obj.title+' 的值'
            },
            elchange2(val){
                let obj ={}
                obj =this.tabCol2.find(item=>{
                    return item.key===val
                })
                this.input_hold2='请输入'+obj.title+' 的值'
            },
            qryTabData(){
                this.getFormData('','',this.selparam,this.textparam,'','' )
            },
            qryTabData2(){
                let v_idseq=!this.selparam2?'idseq':this.selparam2
                this.getFrmFldData('idseq',this.rowIdseq2,'lstseq',this.rowLstseq2, ' and '+v_idseq+' like \'%'+this.textparam2+'%\'')
            },
            rowClassName(row,index){
                if (index ===0){
                  //  return 'ivu-table-row-highlight'
                }
            },
            //获取表行数据
            tabClick (row) {               
                this.rowLstseq2 =row.LSTSEQ
                this.rowIdseq2 =row.IDSEQ
                this.getFrmFldData('idseq',row.IDSEQ,'LSTSEQ',row.LSTSEQ,'' )
            },
 
            //获取表单数据
            getFormData(v_key,v_value,v_key2,v_value2,v_key3,v_value3){
                var vm=this
                this.loading =true
                getTabColOrData(this.v_likeurl,'v_SYS_FORM',v_key,v_value,v_key2,v_value2,v_key3,v_value3,' order by adddttm desc').then((res) => {
                    vm.baseData = res.result
                    if(res.result.length>0){
                        vm.$refs.formref.setCurrentRow(res.result[0] ) 
                        this.rowIdseq =res.result[0].IDSEQ   
                        this.getFormTable('idseq', res.result[0].IDSEQ )         
                    }else{
                        this.getFormTable('idseq', '-1') 
                    }  
                    this.loading =false                 
                });               
            },
            //表单下实体表名称
            getFormTable(v_key,v_value ){
                getTabColOrData(this.v_url,'V_SYS_FORM_TAB',v_key,v_value,'','','','',' order by lstseq').then((res) => {
                    this.tableData = res.result
                    if(res.result.length>0){
                        if(this.rowIdseq2==='-1'){
                            this.rowIdseq2 =res.result[0].IDSEQ
                            this.rowLstseq2=res.result[0].LSTSEQ
                        }
                        this.$refs.tabref.setCurrentRow(res.result[0])
                        this.getFrmFldData('idseq',res.result[0].IDSEQ,'lstseq',res.result[0].LSTSEQ,'')                      
                    }else{
                        this.getFrmFldData('idseq','-1' ,'lstseq','-1' ,'')  
                    }
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout()
                    })
                });               
            },
            //获取表单字段数据
            getFrmFldData(v_key,v_value,v_key2,v_value2, cond_){
                this.v_loading=true
                var vm=this
                this.v_operData =[]
                getTabColOrData(this.v_url,'V_SYS_FORM_FLD',v_key,v_value,v_key2,v_value2,'','',cond_).then((res) => {
                    vm.allList = res.result
                    this.initPage()
                    vm.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.fldref.doLayout()
                        this.v_loading =false
                    })
                });               
            },
            //获取表列头字段
            getTabCol(){
                var vm=this
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','90','FLDTY','HEAD','','',' order by sortby,lstseq').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.tabCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            sortable: res.result[k].sortable?true:false,
                        })
                    }
                });
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','90','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.tabArr.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                        })
                    }
                });
            },
            //获取表列头字段
            getTabCol2(){
                var vm=this
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','90','lstseq','3').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.tabCol2.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            edcss:res.result[k].EDCSS,
                            align: res.result[k].align,
                            thide: res.result[k].THIDE,
                            width: res.result[k].width,
                            fhide: res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            sortable:res.result[k].SORTABLE,
                        })
                    }
                });
            },
        }
}
</script>
<style scoped lang="less">
    /* 设置分割线的粗细 */
    .vue-splitpane-container .vue-splitpane-pane  {
        background-color: rgb(223, 80, 80); /* 分割线颜色 */
        margin-left: 0; /* 左右分割线间距 */
        margin-right: 0;
 
        /* 设置分割线粗细 */
        height: 10px; /* 分割线粗细由高度控制 */
    }
    .handle {
        cursor: move;
        display: flex;
        align-content: center;
    }
</style>
 <style lang="less">
    
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th{
            padding: 0 ;
            display: table-cell!important;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
</style>